import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getBet = (params) => {
    return axios.get(`${backendHost}/api/admin/report-bet`, {params});
};